import { createSelector } from '@ngrx/store';
import { getHistoryOrderByOrderId } from '../getHistoryOrderByOrderId';

export const getHistoryOrderStatus = (orderId: number) =>
    createSelector(
        getHistoryOrderByOrderId(orderId),
        (order) => order?.data?.Status || null
    );
